
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { useConsultorioStore } from '../../store/consultorioStore';
import { consultorioService } from '../../services/ConsultorioService';
import { DateTime } from "luxon";
import { Reporte } from "@/addons/Reporte";

@Component({
	name: "ReporteTratamiento",
	components: { HeadReport: () => import('@/components/HeadReport.vue')
	}
})
export default class ReporteTratamiento extends Vue {

	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	public fechaInicial = DateTime.now().minus({days: 30}).toFormat("yyyy-MM-dd");
	public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
	public tratamiento_id:number|null = null;
	mounted() {
		this.consultorioService.getTratamientos();
	}
	getReporteTratamiento() {
		let data = {
			tratamiento_id: this.tratamiento_id,
			fechaInicial: this.fechaInicial,
			fechaFinal: this.fechaFinal,
		}
		this.consultorioService.getReporteTratamiento(data)
	}

	get ingresos(): any {
		return this.consultorioStore.pagos;
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get tratamientos(): any {
		const tratamientosAll = [{id: null, nombre: 'Todos'}, ...this.consultorioStore.tratamientos];
		return tratamientosAll;
	}
	get dataReporte(): any {
		return this.consultorioStore.dataReporte;
	}
	imprimir() {
    const css = ".print table {border-collapse: collapse} .print td {padding:0.5 !important; font-size: xx-small !important;}"
    const p = new Reporte('area_impresion');
    p.orientacion ='vertical';
    p.otroCss = css;
    p.imprimir();
  }

}
